export default [
    {
        path: '/authorise',
        name: 'authorise',
        component: () => import( /* webpackChunkName: "authorise" */ '@/views/payment/Authorise.vue')
    },
    {
        path: '/bankDetails',
        name: 'bankDetails',
        component: () => import( /* webpackChunkName: "bankDetails" */ '@/views/payment/BankDetails.vue')
    },
    {
        path: '/cards/search',
        name: 'findCard',
        component: () => import( /* webpackChunkName: "findCard" */ '@/views/payment/FindCard.vue')
    },
    {
        path: '/card/:id',
        name: 'card',
        component: () => import( /* webpackChunkName: "card" */ '@/views/payment/Card.vue')
    },
    {
        path: '/customer/:id',
        name: 'customer',
        component: () => import( /* webpackChunkName: "customer" */ '@/views/payment/Customer.vue')
    },
    {
        path: '/issuers',
        name: 'issuers',
        component: () => import( /* webpackChunkName: "issuers" */ '@/views/payment/Issuers.vue')
    },
    {
        path: '/payments/file/:id',
        name: 'paymentFile',
        component: () => import( /* webpackChunkName: "paymentFile" */ '@/views/payment/PaymentFile.vue')
    },
    {
        path: '/process/:id',
        name: 'process',
        component: () => import( /* webpackChunkName: "process" */ '@/views/payment/Process.vue')
    },
    {
        path: '/payments/purposes',
        name: 'paymentPurposes',
        component: () => import( /* webpackChunkName: "paymentPurposes" */ '@/views/payment/Purpose.vue')
    },
    {
        path: '/requests/:id',
        name: 'request',
        component: () => import( /* webpackChunkName: "request" */ '@/views/payment/Request.vue')
    }
]